import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../Box/index.js";
const FormKnownValues = (t0)=>{
    const $ = c(2);
    const { children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "20",
            p: "16",
            bgcolor: "bg.greyscale.primary",
            radius: "l",
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
export { FormKnownValues };
